import { render, staticRenderFns } from "./HeaderSelection.vue?vue&type=template&id=71d2badc"
import script from "./HeaderSelection.vue?vue&type=script&lang=js"
export * from "./HeaderSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports